import { type TransformerConfig } from '../common/types';
import { createDecodeFromDbFn, createEncodeToDbFn } from '../common/utils';
import { createTimestampTransformer } from '../common/sql';
import {
  AttemptSubmissionSchema,
  DBAttemptSubmissionSchema,
  DBListedAttemptSubmissionSchema,
  ListedAttemptSubmissionSchema,
} from './schemas';

export const AttemptSubmissionCodecConfig: TransformerConfig<
  typeof AttemptSubmissionSchema,
  typeof DBAttemptSubmissionSchema
> = {
  name: 'AttemptSubmission',
  clientSchema: AttemptSubmissionSchema,
  dbSchema: DBAttemptSubmissionSchema,
  transformers: [
    createTimestampTransformer<typeof AttemptSubmissionSchema, typeof DBAttemptSubmissionSchema>(
      'submittedAt',
      { nullable: true }
    ),
    createTimestampTransformer<typeof AttemptSubmissionSchema, typeof DBAttemptSubmissionSchema>(
      'createdAt'
    ),
    createTimestampTransformer<typeof AttemptSubmissionSchema, typeof DBAttemptSubmissionSchema>(
      'updatedAt',
      { nullable: true }
    ),
  ],
};

export const encodeAttemptSubmissionToDb = createEncodeToDbFn(AttemptSubmissionCodecConfig);
export const decodeAttemptSubmissionFromDb = createDecodeFromDbFn(AttemptSubmissionCodecConfig);

export const ListedAttemptSubmissionCodecConfig: TransformerConfig<
  typeof ListedAttemptSubmissionSchema,
  typeof DBListedAttemptSubmissionSchema
> = {
  name: 'ListedAttemptSubmission',
  clientSchema: ListedAttemptSubmissionSchema,
  dbSchema: DBListedAttemptSubmissionSchema,
  transformers: [
    createTimestampTransformer<
      typeof ListedAttemptSubmissionSchema,
      typeof DBListedAttemptSubmissionSchema
    >('submittedAt', { nullable: true }),
    createTimestampTransformer<
      typeof ListedAttemptSubmissionSchema,
      typeof DBListedAttemptSubmissionSchema
    >('createdAt'),
    createTimestampTransformer<
      typeof ListedAttemptSubmissionSchema,
      typeof DBListedAttemptSubmissionSchema
    >('updatedAt', { nullable: true }),
    createTimestampTransformer<
      typeof ListedAttemptSubmissionSchema,
      typeof DBListedAttemptSubmissionSchema
    >('uploadedAt'),
  ],
};

export const decodeListedAttemptSubmissionFromDb = createDecodeFromDbFn(
  ListedAttemptSubmissionCodecConfig
);
